export const pages = {
	'films': { id: 'films', page: 'filmPage', getter: () => import(/* webpackChunkName: 'filmPage' */ 'components/bolt/filmPage/filmPage') },
	'aboutUs': { id: 'aboutUs', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'careers': { id: 'careers', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'landing': { id: 'landing', page: 'hub', getter: () => import(/* webpackChunkName: 'hub' */ 'components/bolt/hub/hub') },
	'leadership': { id: 'leadership', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'applicationForm': { id: 'applicationForm', page: 'applicationForm', getter: () => import(/* webpackChunkName: 'applicationForm' */ 'components/bolt/applicationForm/applicationForm') }
};
import hub from 'components/bolt/hub/hub';
import synopsis from 'components/bolt/synopsis/synopsis';
import text from 'components/bolt/text/text';
import imageTiles from 'components/bolt/imageTiles/imageTiles';
import tiledItems from 'components/bolt/tiledItems/tiledItems';
export const sections = [
	{ id: 'aboutHero', isPreloaded: true, component: hub, parent: 'aboutUs' },
	{ id: 'about', isPreloaded: true, component: synopsis, parent: 'aboutUs' },
	{ id: 'contact', isPreloaded: true, component: text, parent: 'aboutUs' },
	{ id: 'leadershipHero', isPreloaded: true, component: hub, parent: 'leadership' },
	{ id: 'leaders', isPreloaded: true, component: imageTiles, parent: 'leadership' },
	{ id: 'careersHero', isPreloaded: true, component: hub, parent: 'careers' },
	{ id: 'listings', isPreloaded: true, component: tiledItems, parent: 'careers' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
